import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { User } from '../../shared/models/user/user.model';

@Component({
  selector: 'personal-info',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './personal-info.component.html',
})
export class PersonalInfoComponent {
  @Input() currentUser!: User | null;
}
